import { styled } from '@vw-marketing/us-components';

export const IconListItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;

  padding: 28px 0px;
  min-height: 114px;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 48px;
`;

export const ContentWrapper = styled.div`
  flex: 1;
`;

export const StyledListIconImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
`;
